import Services from './base-services'

const service = new Services()

export default {
    signIn: (credentials: { email: string; password: string }) => {
        return service.post('sign-in', credentials)
    },
    signOut: () => {
        return service.post('sign-out')
    },
    signUp: (user: any) => {
        return service.post('sign-up', user)
    },
    requestPasswordReset: (email: string) => {
        return service.post('request-password-reset', { email })
    },
    resetPassword: (userId: number) => {
        return service.post('reset-password', { userId })
    },
    updatePassword: (password: string, confirmPassword: string, token: string) => {
        return service.post('update-password', { password, confirmPassword, token })
    },
    getInfoByToken: () => {
        return service.post('token')
    },
}
